import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_security",
  "use": "icon-project_security-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_security\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M20 11l-7.215 8L8 13.695\" /><path d=\"M3 16c0 6.075 4.925 11 11 11s11-4.925 11-11\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 16.094V5.986L14 1l11 4.986v10.055\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol